<template>
  <div :class="`cung cung_${soCung}`">
    <div class="cung_content">
      <div class="c_giap">{{cungA.cungCan}}.<span :class="`color_${cungA.hanhCung}`">{{cungA.cungTen}}</span></div>
      <span class="c_cung"><span :class="{c_cung_has_than: cungA.cungThan}">{{cungA.cungChu}}</span><span v-if="cungA.cungThan" class="color_3 c_cung_than">Thân</span></span>
      <div class="daihan">{{cungA.cungDaiHan}}</div>
      <div class="sao_chinh">
        <p
          v-for="(sao, index) in getSaoChinh(cungA.cungSao)"
          :key="index"
          :class="`sao${index + 1}`"
        >
          <span v-if="checkShowSao(sao)" :class="sao.cssSao">{{sao && sao.saoTen}} <span v-if="sao.saoDacTinh"> ({{sao.saoDacTinh}}) </span></span>
        </p>
      </div>
      <ul class="sao_left">
        <div
          v-for="(sao, index) in getSaoTot(cungA.cungSao)"
          :key="index"
        >
          <li v-if="checkShowSao(sao)">
            <span :class="`${sao.cssSao}`">{{sao && sao.saoTen}} <span v-if="sao.saoDacTinh"> ({{sao.saoDacTinh}}) </span></span>
          </li>
        </div>
        <div
          v-if="getSaoTot(cungA.cungSao).length < getSaoXau(cungA.cungSao).length && isShowTuHoaCp"
          style="margin-top: 10px;border-top: solid 1px #c2baba;"
        >
          <li class="tu-hoa"
              v-for="(sao, index) in cungTuHoa"
              :key="`tuhoa${index}`"
          >
            <span :class="`${sao.cssSao}`">
              {{isTuHoaIn ? sao.viTriCp.length : ''}}<span>{{getSaoTuHoa(sao)}}</span> {{sao.viTriCp.toString()}}
            </span>
          </li>
        </div>
      </ul>
      <ul class="sao_right ul_saoright">
        <div
          v-for="(sao, index) in getSaoXau(cungA.cungSao)"
          :key="index"
        >
          <li v-if="checkShowSao(sao)">
            <span :class="`${sao.cssSao}`">{{sao && sao.saoTen}} <span v-if="sao.saoDacTinh"> ({{sao.saoDacTinh}}) </span></span>
          </li>
        </div>
        <div
          v-if="getSaoTot(cungA.cungSao).length >= getSaoXau(cungA.cungSao).length && isShowTuHoaCp"
          style="margin-top: 10px;border-top: solid 1px #c2baba;"
        >
          <li class="tu-hoa"
              v-for="(sao, index) in cungTuHoa"
              :key="`tuhoa${index}`"
          >
            <span :class="`${sao.cssSao}`">
              {{isTuHoaIn ? sao.viTriCp.length : ''}}<span>{{getSaoTuHoa(sao)}}</span> {{sao.viTriCp.toString()}}
            </span>
          </li>
        </div>
      </ul>
      <div class="tieu_han">năm {{cungA.cungTieuHan}}</div>
      <div class="truong_sinh">{{getTruongSinh(cungA.cungSao)[0].saoTen}}</div>
      <div class="truong_sinh" :id="`point${soCung}`" style="bottom: 35px;"></div>
      <div class="han_thang">tháng {{cungA.cungThangHan}}</div>
      <span v-if="getTuanTrietDv()" :class="`tuan_triet dv triet triet${soCung}`">{{getTuanTrietDv()}}</span>
      <span v-else-if="getTuanTriet()" :class="`tuan_triet triet triet${soCung}`">{{getTuanTriet()}}</span>
    </div>
  </div>
</template>

<script>
import { CAC_LOAI_SAO } from '@/utils/tuvi/sao'
export default {
  name: 'ItemCung',
  props: {
    soCung: {
      type: Number,
      default: null
    },
    cungA: {
      type: Object,
      default: () => {}
    },
    cungB: {
      type: Object,
      default: () => {}
    },
    isShowTuHoaDv: {
      type: Boolean,
      default: false
    },
    isShowTuHoaCp: {
      type: Boolean,
      default: false
    },
    isTuHoaIn: {
      type: Boolean,
      default: false
    },
    showStar: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    cungTuHoa () {
      const cungTuHoa = this.isTuHoaIn ? [...this.cungA.cungTuHoa2] : [...this.cungA.cungTuHoa]
      cungTuHoa.sort((a, b) => a.saoID - b.saoID)
      return cungTuHoa
    },
    showStarIds () {
      if (!this.showStar || !this.showStar.length) {
        return []
      }
      let ids = []
      this.showStar.forEach((type) => {
        if (type.includes('_')) {
          const arr = type.split('_')
          ids = [...ids, Number(arr[1])]
        } else {
          ids = [...ids, ...CAC_LOAI_SAO[type]]
        }
      })
      return ids
    }
  },
  methods: {
    checkShowSao (sao) {
      if (this.showStarIds && this.showStarIds.length) {
        return this.showStarIds.includes(sao.saoID)
      }
      return sao.saoID < 300 || (this.isShowTuHoaDv && sao.saoID > 300)
    },
    getSaoTuHoa (sao) {
      if (!sao) {
        return
      }
      const tenSao = sao.saoTen.split(' ').pop()
      const symbol = this.isTuHoaIn ? ' ←' : ' →'
      if (sao.saoLoai < 10) {
        return tenSao.charAt(0) + symbol
      }
      return tenSao + symbol
    },
    getSaoChinh (data) {
      return data
        .filter((item) => !item.vongTrangSinh && item.saoLoai === 1)
    },
    getSaoTot (data) {
      return data
        .filter((item) => !item.vongTrangSinh && item.saoLoai < 10 && item.saoLoai !== 1)
    },
    getSaoXau (data) {
      return data
        .filter((item) => !item.vongTrangSinh && item.saoLoai > 10)
    },
    getTruongSinh (data) {
      if (this.showStar && this.showStar.length && !this.showStar.includes('vongTruongSinhId')) {
        return [{ saoTen: '' }]
      }
      return data.filter((item) => item.vongTrangSinh)
    },
    getTuanTriet () {
      if (this.showStar && this.showStar.length && !this.showStar.includes('tuanTrietId')) {
        return null
      }
      const isTriet = this.cungA.trietLo && this.cungB.trietLo
      const isTuan = this.cungA.tuanTrung && this.cungB.tuanTrung
      if (isTriet && isTuan) {
        return 'Tuần - Triệt'
      } else if (isTuan) {
        return 'Tuần'
      } else if (isTriet) {
        return 'Triệt'
      }
    },
    getTuanTrietDv () {
      if (this.showStar && this.showStar.length && !this.showStar.includes('tuanTrietId')) {
        return null
      }
      const isTriet = this.cungA.trietLoDv && this.cungB.trietLoDv
      const isTuan = this.cungA.tuanTrungDv && this.cungB.tuanTrungDv
      if (isTriet && isTuan) {
        return 'Tuần - Triệt'
      } else if (isTuan) {
        return 'Tuần'
      } else if (isTriet) {
        return 'Triệt'
      }
      return null
    }
  }
}
</script>

<style scoped src="../../assets/css/tuvi.css" />
<style scoped src="../../assets/css/bootstrap.min.css" />
